module.exports = __webpack_public_path__ + "static/media/baca-background.8738fb83.jpeg";